export default function getNodes(config) {
  let nodes = []

  if (config.children) {
    config.children.forEach(child => {
      nodes = nodes.concat(getNodes(child))
    })
  }

  if (config.type !== 'layout') {
    nodes.push(config)
  }

  return nodes
}
